// extracted by mini-css-extract-plugin
module.exports = {"Tooltip":"peru_Tooltip__1J2TA","Indicador":"peru_Indicador__3xozg","FadeIn":"peru_FadeIn__1JP2T","fadeIn":"peru_fadeIn__2CZlP"};